import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const UploadGlyph = /*#__PURE__*/createElement("g", {
  id: "upload"
}, /*#__PURE__*/createElement("path", {
  d: "M62,67.5H20.6c-2.5,0-4.5-2-4.5-4.5v-8.5h3V63c0,0.8,0.7,1.5,1.5,1.5H62c0.8,0,1.5-0.7,1.5-1.5v-8.5h3V63 C66.5,65.5,64.5,67.5,62,67.5z"
}), /*#__PURE__*/createElement("polygon", {
  points: "49.8,47 41.5,55.2 33.3,47 31,49.3 41.5,59.8 52.1,49.3 \t"
}), /*#__PURE__*/createElement("path", {
  d: "M40.1,32.4c0,7.8,0,15.7,0,23.5c0,1.9,3,1.9,3,0c0-7.8,0-15.7,0-23.5C43.1,30.5,40.1,30.5,40.1,32.4L40.1,32.4z"
}));
const Upload = createSvg({
  name: 'upload',
  path: UploadGlyph
});

export default Upload;
export { UploadGlyph };
